import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { tenantApi } from "@/lib/api/client";

/** "Email me the setup link": has PaperCut send the member its onboarding
 *  email. Shared by the Print page's onboarding card (also a guide block) and
 *  the active account's "Resend instructions". */
export function useStartPrinting(onSent?: () => void) {
  return useMutation({
    mutationFn: () => tenantApi.startPrinting(),
    onSuccess: (res) => {
      toast.success(res.data?.message ?? "Check your email for PaperCut's setup instructions.");
      onSent?.();
    },
    onError: (err: unknown) => {
      // The backend's 429 (rate limit) carries a human message worth showing verbatim.
      const detail = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail;
      toast.error(detail ?? "Could not reach the print system — try again in a few minutes.");
    },
  });
}
